import { render, staticRenderFns } from "./UserAgency.vue?vue&type=template&id=b2690456&scoped=true&"
import script from "./UserAgency.vue?vue&type=script&lang=js&"
export * from "./UserAgency.vue?vue&type=script&lang=js&"
import style0 from "./UserAgency.vue?vue&type=style&index=0&id=b2690456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2690456",
  null
  
)

export default component.exports